// eslint-disable-next-line import/no-extraneous-dependencies
import { assignInlineVars } from "@vanilla-extract/dynamic"
import React from "react"
import type { CreateableContentBlockType } from "types/cms"
import { font } from "lib/theme/theme.css"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { DeprecatedChakraButtonCta } from "packages/acquisition/components/chakra-components/CMS/ButtonCta"
import { container, themeVars, iconContainer } from "./ContentBlock.css"
import {
  colorSwitch,
  fontSizesMobile,
  getFontSize,
  getLineHeight,
  switchLetterSpacing,
} from "../../utils"
import { TagType } from "../TagType"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"

type Props = CreateableContentBlockType & CMSPageProps

export const ContentBlock: React.FC<Props> = ({
  content,
  mobileStyles,
  desktopStyles,
  tagType,
  icon,
  cta,
  trackingModule,
  id,
}) => (
  <div
    className={container}
    data-testid={cleanTitle(`block ${id}`)}
    style={assignInlineVars(themeVars, {
      mobileBlockStyles: {
        width: `${mobileStyles?.width ?? 20}%`,
        height: `${mobileStyles?.height ?? 20}%`,
        left: `${mobileStyles?.left ?? 0}%`,
        top: `${mobileStyles?.top ?? 10}%`,
        font: font[mobileStyles?.font ?? "acuminRegular"],
        textAlign: mobileStyles?.textAlign?.toLowerCase() ?? "center",
        fontSize: `${fontSizesMobile[(mobileStyles?.fontSize ?? 5) - 1]}vw`,
        lineHeight: getLineHeight(
          (mobileStyles?.fontSize ?? 5) - 1,
          mobileStyles?.lineHeight ?? "Normal",
          "mobile"
        ),
        fontColor: colorSwitch(mobileStyles?.fontColor ?? "Black"),
        letterSpacing: switchLetterSpacing(
          mobileStyles?.letterSpacing ?? "normal"
        ),
      },
      desktopBlockStyles: {
        width: `${desktopStyles?.width ?? 20}%`,
        height: `${desktopStyles?.height ?? 20}%`,
        left: `${desktopStyles?.left ?? 0}%`,
        top: `${desktopStyles?.top ?? 10}%`,
        font: font[desktopStyles?.font ?? "acuminRegular"],
        textAlign: desktopStyles?.textAlign?.toLowerCase() ?? "center",
        fontSize: getFontSize(desktopStyles?.fontSize ?? 4),
        lineHeight: getLineHeight(
          desktopStyles?.fontSize ?? 4,
          desktopStyles?.lineHeight ?? "Normal",
          "desktop"
        ),
        fontColor: colorSwitch(desktopStyles?.fontColor ?? "Black"),
        letterSpacing: switchLetterSpacing(
          desktopStyles?.letterSpacing ?? "normal"
        ),
      },
    })}
  >
    {!cta && !icon && (
      <TagType
        content={`<span>${content}</span>`}
        headingSize={tagType ?? "Paragraph"}
        fontColorMob={mobileStyles?.fontColor ?? "Black"}
        fontColorDesktop={desktopStyles?.fontColor ?? "Black"}
      />
    )}
    {cta && !icon && (
      <DeprecatedChakraButtonCta trackingModule={trackingModule} {...cta} />
    )}
    {icon && (
      <div className={iconContainer}>
        <img src={icon.src} alt={icon.title} height={"100%"} width={"100%"} />
      </div>
    )}
  </div>
)
